import PropTypes from "prop-types";

const screenPropTypes = {
  screen: PropTypes.object.isRequired,
  appData: PropTypes.object,
  components: PropTypes.object,
  isRoot: PropTypes.bool
};

export default screenPropTypes;
